import {Price} from "../types"

const subtractCostFromBalance = (balance: Price, cost: Price): Price => {
  const balanceAmount = Number(balance.amount * 100)
  const balanceCurrency = cost.currency.toLowerCase()
  const costAmount = Number(cost.amount * 100)
  const amount = Math.trunc(balanceAmount - costAmount) / 100
  return {
    amount,
    currency: balanceCurrency
  }
}

export default subtractCostFromBalance
